import { Link } from "react-router-dom";
import { Clock } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useLicense } from "@/hooks/useLicense";
import { cn } from "@/lib/utils";

function daysUntil(dateStr: string): number {
  const diff = new Date(dateStr).getTime() - Date.now();
  return Math.max(0, Math.ceil(diff / (1000 * 60 * 60 * 24)));
}

function severity(days: number): { bg: string; text: string; labelKey: string } {
  if (days <= 3) return { bg: "bg-red-50 border-red-200", text: "text-red-800", labelKey: "trialBanner.upgradeToKeepData" };
  if (days <= 7) return { bg: "bg-amber-50 border-amber-200", text: "text-amber-800", labelKey: "trialBanner.upgradeNow" };
  return { bg: "bg-blue-50 border-blue-200", text: "text-blue-800", labelKey: "trialBanner.upgradeToPro" };
}

export function TrialBanner() {
  const { t } = useTranslation();
  const { license, loading } = useLicense();

  if (loading || !license?.expires_at) return null;
  if (license.status !== "trial" && license.plan !== "community") return null;

  const days = daysUntil(license.expires_at);
  if (days > 90) return null;
  const s = severity(days);

  return (
    <div className={cn("mb-4 flex items-center justify-between rounded-md border px-4 py-2", s.bg)} role="alert">
      <div className={cn("flex items-center gap-2 text-sm font-medium", s.text)}>
        <Clock className="h-4 w-4" />
        <span>{t("trialBanner.daysRemaining", { count: days })}</span>
      </div>
      <Link
        to="/license"
        className={cn("text-sm font-semibold underline underline-offset-2", s.text)}
      >
        {t(s.labelKey)}
      </Link>
    </div>
  );
}
